import styled from "styled-components";

// Re-export icons from central icons file
export { HomeIcon, BackIcon, DocumentIcon, LoginIcon } from "../icons";

// ============ Styled Components ============

export const NavWrapper = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 0 20px;
  height: 70px; /* Fixed height for consistency */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.03); /* Lighter "Frost" effect */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
  background: rgba(12, 7, 33, 0.9);

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 12px 16px;
  }
`;

export const NavLayoutWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1000px; /* User requested specific width */
  margin: 0 auto;
`;

export const NavLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 32px; /* More spacing */
`;

export const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const NavButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: inherit;
  color: #94a3b8; /* Muted text by default */
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.05);
  }

  /* Primary button style (e.g. My Documents) */
  ${({ $primary }) =>
    $primary &&
    `
    color: #ffffff;
    background: rgba(59, 130, 246, 0.1);
    border: 1px solid rgba(59, 130, 246, 0.2);
    
    &:hover {
      background: rgba(59, 130, 246, 0.2);
      border-color: rgba(59, 130, 246, 0.4);
      transform: translateY(-1px);
    }
  `}

  svg {
    width: 16px;
    height: 16px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 8px;

    span {
      display: ${({ $primary }) => ($primary ? "inline" : "none")};
    }
  }
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #94a3b8;

  &:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.05);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
